import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'
import { UpdatePurchaseOrderItemMessage } from '@/@types/messages/UpdatePurchaseOrderItemMessage'

export class PurchaseOrderItemService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public deletePurchaseOrderItem(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/purchase-order-items/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updatePurchaseOrderItem(purchaseOrderItemId: number, updatePurchaseOrderItemMessage: UpdatePurchaseOrderItemMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatePurchaseOrderItemMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/purchase-order-items/${purchaseOrderItemId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
